import type { ReactElement } from 'react';

import styles from './AccountSectionSpacer.module.scss';

export function AccountSectionSpacer(): ReactElement {
  return <div className={styles['account-section-spacer']} />;
}
